import React from 'react';
import debounce from 'lodash/debounce';
import ResizeObserver from 'resize-observer-polyfill';

// --------------------------------------------------------------------


function getBody() {
  if (typeof document !== 'undefined') {
    return document.documentElement;
  }

  return {
    clientWidth: 1024,
    clientHeight: 800
  };
}

function getViewport() {
  const body = getBody();
  const { clientWidth: width, clientHeight: height } = body;
  const isMobile = width < 1024;

  return {
    width,
    height,
    isMobile,
    isDesktop: !isMobile
  };
}

// --------------------------------------------------------------------

const WithViewportSize = WrappedComponent => {
  return class extends React.Component {
    state = {
      viewport: getViewport()
    };

    componentDidMount() {
      this.resizeObserver = new ResizeObserver(debounce(() => {
        this.updateSize();
      }, 500));

      this.resizeObserver.observe(getBody());
      this.updateSize();
    }

    componentWillUnmount() {
      this.resizeObserver.disconnect();
    }

    updateSize() {
      this.setState({ viewport: getViewport() });
    }

    render() {
      const { viewport } = this.state;

      return <WrappedComponent
        ref={(ref) => {
          this.component = ref
        }
        }
        viewport={viewport}
        {...this.props}
      />;
    }
  };
};

// --------------------------------------------------------------------

export { WithViewportSize, getViewport };

